<template>
  <div class="left padding">
    <h2 class="titles">{{ $t("consultaFichero.titulo") }}</h2>
    <Card class="cardClass">
      <template slot="content">
        <div class="grid">
          <div class="lg:col-2 sm:col-12 autoMargin">
            <span class="dot autoMargin center">
              <strong class="circleTextBigFont"
                ><img src="@/assets/consultas/entidad.png"
              /></strong>
            </span>
          </div>
          <div class="lg:col-6 sm:col-12 autoMargin">
            <h2 class="titles">
              {{ $t("consultaFichero.label.solicitudAccesoMisDatos") }}
            </h2>
            <p class="explanation">
              {{ $t("consultaFichero.explanationDatosPropios") }}
            </p>
          </div>
          <div class="lg:col-4 sm:col-12 center autoMargin">
            <Button
              @click="solicitarAccesoDatosPropios()"
              :label="$t('consultaFichero.button.solicitar')"
              class="buttonStyle lightBlueBG"
            />
          </div>
        </div>
      </template>
    </Card>
    <template v-for="tipoProducto in tiposProducto">
      <CardReclamacion
        :key="tipoProducto.codigo"
        :tipoContrato="tipoProducto.codigo"
        :precio="tipoProducto.tarifa"
        :nombre="tipoProducto.nombre"
        :descripcion="tipoProducto.descripcion"
        :tipo="tipoProducto.tipo"
      />
    </template>
  </div>
</template>

<script>
import CardReclamacion from "@/components/portal-cliente/Utils/CardReclamacion.vue";
import { QUERY_PRODUCTOS_ACTIVOS_BUSQUEDA } from "@/graphQLQueries/TipoProductoQueries";

export default {
  name: "ConsultaFicheroMain",
  props: {},
  components: {
    CardReclamacion,
  },
  data() {
    return {
      tiposProducto: [],
    };
  },
  methods: {
    solicitarAccesoDatosTercero() {
      this.$router.push({ name: "consultaFichero" });
    },
    solicitarAccesoDatosPropios() {
      // TODO esto es temporal hasta que se defina la pantalla
      //this.$router.push({ name: 'formularioDatosPropios' })
      window.open(
        "https://derechos.iciredimpagados.com/hc/es-es/articles/360020674620"
      );
    },
  },
  apollo: {
    tiposProducto: {
      query: QUERY_PRODUCTOS_ACTIVOS_BUSQUEDA,
      update(data) {
        return data.listaProductosBusquedaActivosIciredPortalClientes;
        //.filter((producto) => producto.tarifa === 0)// TODO. Pagar por las consultas.
        //.sort((a,b) => (a.tarifa > b.tarifa) ? 1 : ((b.tarifa > a.tarifa) ? -1 : 0));
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.padding {
  padding: 2%;
}
</style>